<div class="unsuccessful-snackbar-wrapper">
  <div class="content-wrapper">
    <i class="error-icon"></i>
    <div class="text-wrapper">
      <span class="main-text">Failed</span>
      @if (data) {
        <span class="supporting-text"></span>
      }
    </div>
  </div>

  <mat-icon (click)="closeSnackBar()">close</mat-icon>
</div>
